import { formatTimestamp } from '@utils/timeUtils';
import { FormattedMessage } from 'react-intl';
import { Claim } from 'src/types/sentinel';

import './VideoDetectedClaims.css';

interface VideoDetectedClaimsProps {
	claims: Claim[];
	onViewDetails?: () => void;
}

export default function VideoDetectedClaims({ claims, onViewDetails }: VideoDetectedClaimsProps) {
	const visibleClaims = claims.slice(0, 6);
	const remainingCount = claims.length - visibleClaims.length;
	const tooltipText = visibleClaims
		.map((claim) => {
			const { minutes, seconds } = claim.timestamp_range.start;
			const time = formatTimestamp(minutes, seconds);
			return `${time} ${claim.claim}`;
		})
		.join(' • ');
	return (
		<section id="video-detected-claims">
			<h3 title={tooltipText}>
				<span>
					<FormattedMessage id="sentinel.video-detected-claims.title" /> ({claims.length})
				</span>
				<button onClick={onViewDetails}>
					<FormattedMessage id="view-all" />
				</button>
			</h3>
			<ul>
				{visibleClaims.map((claim, i) => {
					const { minutes, seconds } = claim.timestamp_range.start;
					return (
						<li key={i}>
							<span>
								<strong>
									<span>{formatTimestamp(minutes, seconds)}</span>
								</strong>
								<span title={claim.claim} className="ellipsis">
									{claim.claim}
								</span>
							</span>
						</li>
					);
				})}
			</ul>
			{remainingCount > 0 && (
				<button onClick={onViewDetails} className="claims-remaining">
					<strong>+{remainingCount}</strong> <FormattedMessage id="sentinel.video-detected-claims.title" />
				</button>
			)}
		</section>
	);
}
